import { useBrand } from "@/contexts/BrandContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { useCallback } from "react";

const CURRENCY_DISPLAY: Record<string, { en: string; ar: string }> = {
  SAR: { en: "SAR", ar: "ريال" },
  ريال: { en: "SAR", ar: "ريال" },
  "﷼": { en: "SAR", ar: "ريال" },
  USD: { en: "$", ar: "$" },
  "$": { en: "$", ar: "$" },
  EUR: { en: "€", ar: "€" },
  "€": { en: "€", ar: "€" },
  GBP: { en: "£", ar: "£" },
  "£": { en: "£", ar: "£" },
  AED: { en: "AED", ar: "د.إ" },
  "د.إ": { en: "AED", ar: "د.إ" },
  KWD: { en: "KWD", ar: "د.ك" },
  "د.ك": { en: "KWD", ar: "د.ك" },
  QAR: { en: "QAR", ar: "ر.ق" },
  "ر.ق": { en: "QAR", ar: "ر.ق" },
  BHD: { en: "BHD", ar: "د.ب" },
  "د.ب": { en: "BHD", ar: "د.ب" },
  OMR: { en: "OMR", ar: "ر.ع" },
  "ر.ع": { en: "OMR", ar: "ر.ع" },
  EGP: { en: "EGP", ar: "ج.م" },
  "ج.م": { en: "EGP", ar: "ج.م" },
  JOD: { en: "JOD", ar: "د.أ" },
  "د.أ": { en: "JOD", ar: "د.أ" },
};

function getLocalizedCurrencySymbol(symbol: string, language: string): string {
  const mapping = CURRENCY_DISPLAY[symbol];
  if (mapping) {
    return language === "ar" ? mapping.ar : mapping.en;
  }
  return symbol;
}

export function useFormatPrice() {
  const { brand } = useBrand();
  const { language } = useLanguage();
  
  const formatPrice = useCallback(
    (amount: number) => {
      const symbol = getLocalizedCurrencySymbol(brand.currencySymbol, language);
      return `${symbol} ${amount.toFixed(2)}`;
    },
    [brand.currencySymbol, language]
  );

  return formatPrice;
}
